/**
 * @todo Удалить файл
 * @description Данный функционал появился в задаче CD-195420, будет удалён в задаче CD-195730
 */

import { IAppState } from '../../common/state';
import { isAbUseExperimentGroup } from '../../utils/experiments/isAbUseExperimentGroup';

export const NEWBUILDING_NEW_DESIGN_TGB_ON_LISTING_EXPERIMENT = 'newbuilding_new_design_tgb_on_listing';

export function isNewbuildingNewDesignTgbOnListingExpEnabledSelector(state: IAppState): boolean {
  if (!state.config.get<boolean>('NewbuildingNewDesignTgbOnListing.Enabled')) {
    return false;
  }

  return isAbUseExperimentGroup(state.abUseExperiments, NEWBUILDING_NEW_DESIGN_TGB_ON_LISTING_EXPERIMENT, 'new_tgb');
}
